import { AccountInfo, BrowserCacheLocation, Configuration, IPublicClientApplication, PublicClientApplication, SilentRequest } from '@azure/msal-browser';
import * as angular from 'angular';

interface MsalConfiguration {
    clientId: string;
    authority?: string;
    redirectUri?: string;
}

export interface IMsalAuthenticationService {
    acquireTokenSilent: () => Promise<{ accessToken: string }>;
    clearCache: () => void;
    loginPopup: (scopes: string[]) => Promise<{ accessToken: string }>;
}

export class MsalAuthenticationProvider implements angular.IServiceProvider {
    static serviceId = 'msalAuthenticationService';

    private _msalInstance: IPublicClientApplication;

    async init(configOptions: MsalConfiguration) {
        const msalConfig: Configuration = {
            auth: configOptions,
            cache: { cacheLocation: BrowserCacheLocation.LocalStorage }
        };
        this._msalInstance = await PublicClientApplication.createPublicClientApplication(msalConfig);
    }

    $get = [
        () => {
            const retval: IMsalAuthenticationService = {
                acquireTokenSilent: () => {
                    const account = this._msalInstance.getActiveAccount();
                    const request: SilentRequest = {
                        scopes: ['user.read'],
                        account
                    };
                    return this._msalInstance.acquireTokenSilent(request);
                },
                clearCache: () => {
                    if (this._msalInstance) {
                        this._msalInstance.clearCache();
                    }
                },
                loginPopup: (scopes: string[]) => {
                    return this._msalInstance.loginPopup({ scopes });
                }
            };
            return retval;
        }
    ];
}
